
<template lang="pug">
  .radio-group(:class="inputClass")
    radio-input(
      v-for="option in options",
      :key="option.value",
      v-model="currentValue",
      :label="option.label",
      :value="option.value",
      :disabled="disabled"
    )
    span(v-if="error") {{ error }}
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue'
  import RadioInput from 'scripts/components/forms/RadioInput.vue'

  export default {
    name: 'RadioInputGroup',
    extends: TextInput,
    components: { RadioInput },
    props: {
      options: {
        type: Array,
        required: true,
        default: () => []
      },
      group: {
        type: String,
        required: true
      },
      value: String
    },
    computed: {
      inputClass () {
        return {
          disabled: this.disabled
        }
      }
    },
    created () {
      this.currentValue = this.value ? this.value : this.options[0].value;
    },
    methods: {
      onChange () {
        this.$emit('input', this.currentValue);
      }
    }
  };
</script>

<style scoped lang="scss">
  .radio-group {
    &.disabled {
      opacity: 0.3;
    }
  }
</style>
